import axios from "axios";
import http from "@/api/http/http";

export default {
  getCount (params: null, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.get(`${process.env.VUE_APP_API}/admin/request-consulting/statics`, header)
      .then(cb)
      .catch(errCb)
  }
}